export const locale = {
    lang: 'ar',
    data: {
        PLACE: 'أين تريد وضع هذه القوائم؟',
        ACTIVITY: 'نشاط',
        CANCEL: 'إلغاء',
        SAVE: 'حِفْظْ',
    }
};
